/*global jQuery*/
/**
 * {{name}}
 * Global JS
 *
 * version: {{version}}
 * file:    {{file}}
 * author:  Squiz Australia
 * change log:
 *     {{date}} - First revision
 */

/*
 * Table of Contents
 *
 * - Global
 * - Modules
{{toc}}
 */
'use strict';
/*
--------------------
Global
--------------------
*/
//  Declare JS Enabled.
$('body').removeClass('no-js').addClass('js-enabled');

(function($) {

    // Scroll to anchor
    $('[data-scroll-to]').on('click', function (e) {
        e.preventDefault();
        var target = ('#' + $(this).data('scroll-to')).replace(/^#+/, '#');
        var $target = $(target);
        var targetTop = $target.offset().top;

        $('html, body').stop().animate({
            'scrollTop': targetTop
        }, 1000, 'swing', function () {
            window.location.hash = target;
        });

    });

}(jQuery));

// Marketo utm_source
(function($) {

    if (typeof $.cookie('fb_utm_source') === 'undefined') {

        // utm_source was not found in the cookie

        // first check the URL for utm params
        $.urlParam = function(name){
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (results==null) {
                return null;
            } else {
                return results[1] || 0;
            }
        }

        var url_utm_source      = $.urlParam('utm_source');
        var url_utm_medium      = $.urlParam('utm_medium');
        var url_utm_campaign    = $.urlParam('utm_campaign');
        var url_utm_content     = $.urlParam('utm_content');
        var url_utm_term        = $.urlParam('utm_term');

        // Get the referrer domain name as it might need to use it if utm_source is not found in the query string.
        var referrer       = document.referrer;
        var referrerDomain = null;
        if (referrer !== '') {
            referrerDomain = new URL(referrer).hostname;
            if(referrerDomain.indexOf('.google.') > 0) {
                referrerDomain = 'google';
            }
        }

        var utm_source   = (url_utm_source) ? url_utm_source : (referrerDomain ? referrerDomain : 'unknown'),
            utm_medium   = (url_utm_medium) ? url_utm_medium : 'organic',
            utm_campaign = (url_utm_campaign) ? url_utm_campaign : null,
            utm_content  = (url_utm_content) ? url_utm_content : null,
            utm_term     = (url_utm_term) ? url_utm_term : null;

        // store the utm values in the cookie
        $.cookie('fb_utm_source',   utm_source);
        $.cookie('fb_utm_medium',   utm_medium);
        $.cookie('fb_utm_campaign', utm_campaign);
        $.cookie('fb_utm_content',  utm_content);
        $.cookie('fb_utm_term',     utm_term);

    }

    // Add hidden utm fields to all forms except quick-search
    var $leadCaptureForms = $('form.mktoForm');
    if($leadCaptureForms.length) {

        $('<input>').attr({
            type: 'hidden',
            name: 'utm_source',
            value: $.cookie('fb_utm_source')
        }).appendTo($leadCaptureForms);

        $('<input>').attr({
            type: 'hidden',
            name: 'utm_medium',
            value: $.cookie('fb_utm_medium')
        }).appendTo($leadCaptureForms);

        $('<input>').attr({
            type: 'hidden',
            name: 'utm_campaign',
            value: $.cookie('fb_utm_campaign')
        }).appendTo($leadCaptureForms);

        $('<input>').attr({
            type: 'hidden',
            name: 'utm_content',
            value: $.cookie('fb_utm_content')
        }).appendTo($leadCaptureForms);

        $('<input>').attr({
            type: 'hidden',
            name: 'utm_term',
            value: $.cookie('fb_utm_term')
        }).appendTo($leadCaptureForms);

        $('<input>').attr({
            type: 'hidden',
            name: 'LeadSource',
            value: 'Website'
        }).appendTo($leadCaptureForms);

    }

    //load only for production
    if (window.location.host == 'funnelback.com' || window.location.host == 'www.funnelback.com') {

        // Loading Marketo's munchkin JS
        $.ajax({
            // Don't load marketo code during local dev!
            // and don't merge this into live JS !! :)
            url: document.location.protocol + '//munchkin.marketo.net/munchkin.js',
            dataType: 'script',
            cache: true,
            success: function() {

                Munchkin.init('255-DNB-634');

                $.getScript('//app-sn02.marketo.com/js/forms2/js/forms2.min.js');

                // Setting fb_lead_id cookie
                // Give it a bit more time
                setTimeout(function() {

                    // Check if fb_lead_id has not been set
                    if (typeof $.cookie('fb_lead_id') === 'undefined'){
                        // Check if _mkto_trk exists
                        if (typeof $.cookie('_mkto_trk') !== 'undefined'){

                            var apiUrl = 'https://www.funnelback.com/api/marketo?action=getLead&nocache';

                            $.ajax({
                                type: 'POST',
                                url: apiUrl,
                                dataType: 'json',
                                success: function(data) {
                                    if(data.result.leadRecordList.leadRecord.Id != null && data.result.leadRecordList.leadRecord.Email != null) {
                                        document.cookie = 'fb_lead_id='+ data.result.leadRecordList.leadRecord.Id;
                                        apiFeedback($.cookie('fb_lead_id'));
                                    } else {
                                        apiFeedback('Nothing happened because lead is unknown');
                                    }
                                }
                            });
                        } else {
                            apiFeedback('Nothing happened because munckin didnt load cookie in time');
                        }
                    } else {
                        apiFeedback('Nothing happened because custom lead cookie is already set');
                    }

                }, 500);

            }
        });

    }

}(jQuery));


/*
--------------------
Modules
--------------------
*/

// This is for testing do what you want in global.js
function apiFeedback(msg) {
    if (window.console) {
        console.log(msg);
    }
}

// Match media helpers providing pixel values for
// media queries based on computed font size.
var mediaQueries = (function(){
    var baseFontSize = 16;

    if (window.getComputedStyle) {
        var computedFontSize = window.getComputedStyle(document.body,null).getPropertyValue('font-size');
        baseFontSize = parseFloat(computedFontSize.replace(/(px|rem|em|pt)$/, ''));
    }

    var mqRelSizes = {
        global:    0,
        medium:    48,
        wide:      60,
        extraWide: 96.25
    };

    // Create a list of media queries accessible to JS modules
    var queries = {};
    for (var mqName in mqRelSizes) {
        if (mqRelSizes.hasOwnProperty(mqName)) {
            queries[mqName] = {
                rel: mqRelSizes[mqName],
                pixel: Math.round(baseFontSize*mqRelSizes[mqName]),
                mql: window.matchMedia('(min-width: ' + mqRelSizes[mqName] + 'em)')
            };
        }
    }

    return queries;
}());
